<template>
  <div>
    <el-dialog
      width="1600px"
      title="工艺列表"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="page-main">
        <el-button v-if="isAdmin" class="m-b-10" type="success" size="mini" @click="itemDo()">
          新增模板
        </el-button>
        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          v-bind="tableOptions"
          :height="this.$util.getViewHeight() - 280"
          :cell-class-name="cellClassName"
        >
          <!-- slot_header -->
          <template #header_input="{ column }">
            <c-table-header
              :title="column.title"
              :field="column.field"
              :url="headerFilterUrl"
              @change="headerFilterChange"
            />
          </template>

          <!-- slot_default -->
          <template #default_create_date="{ row }">
            {{ row.create_date ? row.create_date.slice(0, 10) : '' }}
          </template>

          <template #default_operate="{ row }">
            <el-link v-if="row.id !== bind_id" type="success" @click="itemChoose(row)"
              >选择该工艺</el-link
            >
            <el-link type="primary" @click="itemDo(row.id)">编辑</el-link>
          </template>

          <!-- slot_pager -->
          <template #pager>
            <div></div>
            <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
    </el-dialog>
    <!-- 弹窗-增改模板 -->
    <PopupDoMuBan
      v-if="isShowPopupDoMuBan"
      :show.sync="isShowPopupDoMuBan"
      :detailId="detailId"
      @success="searchListData"
    />
  </div>
</template>

<script>
import PopupDoMuBan from '@/views/goods/system/mu-ban/common/popup-do-mu-ban'
export default {
  components: {
    PopupDoMuBan
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    bind_id: {
      type: [Number, String, Object],
      default: ''
    }
  },
  data() {
    return {
      selfShow: false,
      filterData: {},
      detailId: '',
      isShowPopupDoMuBan: false,
      headerFilterUrl: '/admin/gcvip/muBan/searchHeard',
      tableOptions: {
        loading: true,
        size: 'mini',
        border: true,
        pagerConfig: {
          ...this.$constant.page
        },
        columns: [
          {
            fixed: 'left',
            title: '序号',
            type: 'seq',
            width: 40
          },
          { field: 'lei_mu_lei_xing', title: '商品类目类型', slots: { header: 'header_input' } },
          { field: 'category1', title: '一级类目', slots: { header: 'header_input' } },
          { field: 'category2', title: '二级类目', slots: { header: 'header_input' } },
          { field: 'category3', title: '三级类目', slots: { header: 'header_input' } },
          { field: 'category4', title: '四级类目', slots: { header: 'header_input' } },
          { field: 'texture', title: '材质', slots: { header: 'header_input' } },
          { field: 'mu_ban_ming_cheng', title: '商品模板名称', slots: { header: 'header_input' } },
          {
            field: 'mu_ban_guan_jian_ci',
            title: '商品模板关键词',
            slots: { header: 'header_input' }
          },
          { field: 'create_name', title: '创建人', slots: { header: 'header_input' } },
          {
            field: 'create_date',
            title: '创建时间',
            slots: { header: 'header_input', default: 'default_create_date' }
          },
          { title: '操作', slots: { default: 'default_operate' } }
        ],
        data: []
      }
    }
  },
  computed: {
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.searchListData()
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.tableOptions.loading = true
      let params = {
        currentPage: this.tableOptions.pagerConfig.currentPage,
        pageSize: this.tableOptions.pagerConfig.pageSize,
        bao_han: ['加工'],
        filterData: this.filterData,
        sortData: { id: 'desc' }
      }
      if (this.bind_id) params.choose_ids = [this.bind_id]
      this.$api({
        method: 'post',
        url: '/admin/gcvip/muBan/list',
        data: params
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableOptions.data = res.data.page.list
            this.tableOptions.pagerConfig.pageSize = res.data.page.pageSize
            this.tableOptions.pagerConfig.total = res.data.page.totalRow
            this.tableOptions.pagerConfig.currentPage = res.data.page.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.getListData()
    },
    // 行-已选样式
    cellClassName(rowData) {
      let result = rowData.row.id === this.bind_id ? 'table-row-choose' : ''
      return result
    },
    // 项-增改
    itemDo(id = '') {
      this.detailId = id
      this.isShowPopupDoMuBan = true
    },
    // 项选择
    itemChoose(row) {
      this.selfShow = false
      this.$emit('update:show', false)
      this.$emit('success', row)
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
